import _extends from "@babel/runtime/helpers/esm/extends";
var _g, _defs;
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var SvgJumia = function SvgJumia(props) {
  return /*#__PURE__*/_jsxs("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    children: [_g || (_g = /*#__PURE__*/_jsx("g", {
      clipPath: "url(#jumia_svg__a)",
      children: /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M-.48-.48h35.96v35.96H-.48V-.48Zm19.5 8.976a5.464 5.464 0 1 0-.002 10.927 5.464 5.464 0 0 0 .002-10.927Zm0 7.592-2.253 1.184.43-2.507-1.82-1.776 2.517-.366 1.126-2.282 1.125 2.282 2.518.367-1.822 1.775.43 2.507-2.251-1.184Zm-3.23 4.47a.837.837 0 0 0-1.362-.972l-4.591 6.432a.837.837 0 1 0 1.362.972l4.59-6.431Zm2.744.231c.367.28.438.806.157 1.173l-2.32 3.036a.837.837 0 1 1-1.33-1.016l2.32-3.036a.837.837 0 0 1 1.173-.157Zm-4.99-2.32a.837.837 0 0 0-1.33-1.016l-2.271 2.972a.837.837 0 0 0 1.33 1.016l2.27-2.972Z",
        fill: "currentColor"
      })
    })), _defs || (_defs = /*#__PURE__*/_jsx("defs", {
      children: /*#__PURE__*/_jsx("clipPath", {
        id: "jumia_svg__a",
        children: /*#__PURE__*/_jsx("path", {
          fill: "#fff",
          d: "M0 0h35v35H0z"
        })
      })
    }))]
  }));
};
export default SvgJumia;